/**
 * 设备检测工具
 */

// 设备类型常量
export const DEVICE_TYPES = {
  MOBILE: 'mobile',    // <= 768px
  TABLET: 'tablet',    // 768px - 1024px
  DESKTOP: 'desktop'   // > 1024px
}

// 断点配置
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024
}

/**
 * 获取当前设备类型
 * @returns {string} 'mobile' | 'tablet' | 'desktop'
 */
export function getDeviceType() {
  const width = window.innerWidth
  if (width <= BREAKPOINTS.MOBILE) return DEVICE_TYPES.MOBILE
  if (width <= BREAKPOINTS.TABLET) return DEVICE_TYPES.TABLET
  return DEVICE_TYPES.DESKTOP
}

/**
 * 判断是否为移动端（手机）
 * @returns {boolean}
 */
export function isMobile() {
  return getDeviceType() === DEVICE_TYPES.MOBILE
}

/**
 * 判断是否为平板
 * @returns {boolean}
 */
export function isTablet() {
  return getDeviceType() === DEVICE_TYPES.TABLET
}

/**
 * 判断是否为PC端
 * @returns {boolean}
 */
export function isDesktop() {
  return getDeviceType() === DEVICE_TYPES.DESKTOP
}

/**
 * 判断是否为小屏幕（手机或平板）
 * @returns {boolean}
 */
export function isSmallScreen() {
  const deviceType = getDeviceType()
  return deviceType === DEVICE_TYPES.MOBILE || deviceType === DEVICE_TYPES.TABLET
}

/**
 * 创建响应式设备检测对象（用于Vue组件data）
 * @param {Function} callback 设备变化回调
 * @returns {Object} 包含状态和清理方法
 */
export function createDeviceDetector(callback) {
  const state = {
    deviceType: getDeviceType(),
    isMobile: isMobile(),
    isTablet: isTablet(),
    isDesktop: isDesktop(),
    isSmallScreen: isSmallScreen()
  }

  const updateState = () => {
    const newDeviceType = getDeviceType()
    if (state.deviceType !== newDeviceType) {
      state.deviceType = newDeviceType
      state.isMobile = isMobile()
      state.isTablet = isTablet()
      state.isDesktop = isDesktop()
      state.isSmallScreen = isSmallScreen()
      callback && callback(state)
    }
  }

  const start = () => {
    window.addEventListener('resize', updateState)
  }

  const stop = () => {
    window.removeEventListener('resize', updateState)
  }

  return { state, start, stop }
}

export default {
  DEVICE_TYPES,
  BREAKPOINTS,
  getDeviceType,
  isMobile,
  isTablet,
  isDesktop,
  isSmallScreen,
  createDeviceDetector
}
